var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSync = function SvgSync(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13 7.101.01.001a5.005 5.005 0 0 1 3.889 3.89 5.1 5.1 0 0 1-.001 2.016 4.98 4.98 0 0 1-1.363 2.527l1.414 1.414a7 7 0 0 0 1.908-3.54 7 7 0 0 0 0-2.819 6.96 6.96 0 0 0-1.907-3.539 6.97 6.97 0 0 0-3.538-1.908c-.137-.028-.275-.043-.412-.063V2L9 6l4 4zm-7.45 7.623c.174.412.392.812.646 1.19a7.034 7.034 0 0 0 3.078 2.535c.425.18.868.317 1.315.408.167.034.338.056.508.078v2.944l4-4-4-4v3.03c-.035-.006-.072-.003-.107-.011a5 5 0 0 1-2.526-1.362 4.995 4.995 0 0 1 .001-7.071L7.051 7.05A6.974 6.974 0 0 0 5 12c0 .936.186 1.862.55 2.724"
  })));
};
export default SvgSync;